import React from "react";

const ToggleButton = ({ label, isActive, onClick, ...restProps }) => {
  const buttonStyle = isActive
    ? "bg-blue-800 text-white"
    : "bg-blue-300 text-white";

  const marginStyle = isActive ? "mr-[-20px] ml-[-1px]" : "mr-[-20px] ml-[1px]";

  return (
    <button
      {...restProps}
      onClick={onClick}
      className={`py-1 px-9 rounded-xl ${buttonStyle} ${marginStyle} transition duration-300 ease-in-out`}
    >
      {label}
    </button>
  );
};

export default ToggleButton;
